import {Button, Flex, message, Modal, Slider} from 'antd'
import React, {FC, useRef, useState} from 'react'
import AvatarEditor from "react-avatar-editor";


interface EditMainCourseImageProps {
    isOpen: boolean,
    save: (file: File) => void,
    close: () => void,
    file?: any,
    loading: boolean,

}

const EditMainCourseImage: FC<EditMainCourseImageProps> = ({isOpen, close, file, save, loading}) => {

    const inputRef = useRef<any>(null)
    const [scale, setScale] = useState<number>(1.2)

    const clearAndClose = () => {
        setScale(1.2)
        close()
    }

    const saveImage = () => {
        if (inputRef.current) {
            const canvas = inputRef.current.getImageScaledToCanvas().toDataURL()
            fetch(canvas)
                .then(res => res.blob())
                .then(blob => {
                    save(blob as File)
                })
        }
    }

    return (
        <Modal title='Редактирвоание изображения курса'
               onCancel={clearAndClose}
               footer={[
                   <Button
                       type='primary'
                       onClick={saveImage}
                       loading={loading}
                   >
                       Сохранить
                   </Button>
               ]}
               width="auto"
               style={{ maxWidth: 1300 }}
               open={isOpen}>
            {file
                && <><AvatarEditor
                    image={file}
                    ref={inputRef}
                    width={1200}
                    height={524}
                    color={[255, 255, 255, 0.6]} // RGBA
                    scale={scale}
                    rotate={0}
                />
                    <Flex style={{ marginTop: 24 }}>
                        <span style={{ marginTop: 5 }}>Масштаб:</span>
                        <Slider
                            min={1}
                            max={10}
                            step={0.1}
                            value={scale}
                            onChange={setScale}
                            style={{ width: 300, display: 'inline-block' }}
                        />
                    </Flex>
            </>
            }
        </Modal>
    )
}

export default EditMainCourseImage;
